import React from 'react'
import { PageContextProvider } from './src/context/page-context'

export const wrapPageElement = ({ element, props }) => (
  <PageContextProvider value={props.pageContext}>{element}</PageContextProvider>
)
